<template>
  <div class="head" :class="{'common_head':isActive}" :style="{backgroundImage:'url(' + is_top + ')'}" >
      <div class="head_fl fl" @click="$router.push('/')">
        {{title}}
      </div>
      <div class="head_fr fr">
        <img src="../assets/images/home/user_pic.png" alt="" class="user_pic" @click="userClick"  v-if="user.avatar===''">
		<img :src="user.avatar" alt="" class="user_pic" @click="userClick"  v-else>
        <span>{{user.nickname}}</span>
<!--        <img src="../assets/images/home/top_search.png" alt="" class="search" @click="searchClick">-->
<!--        <img src="../assets/images/home/top_message.png" alt="" class="message" @click="messageClick">-->
        <el-dropdown >
            <img src="../assets/images/home/top_set.png" alt="" class="set">
            <el-dropdown-menu slot="dropdown" class="pic-drop">
                <el-tooltip content="提示文字" placement="left-start" effect="light">
                    <el-dropdown-item @click.native="set">基本设置</el-dropdown-item>
                </el-tooltip>
				<el-dropdown-item @click.native="person" v-if='user.is_verify==1'>个人实名认证</el-dropdown-item>
				<el-dropdown-item @click.native="company"  v-if='user.is_verify==2'>企业实名认证</el-dropdown-item>
				<el-dropdown-item @click.native="enterpriseSet"  v-if='user.is_verify==3'>企业设置</el-dropdown-item>
				<el-dropdown-item @click.native="enterprise"  v-if='user.is_verify==3 && is_company===false'>切换企业账号</el-dropdown-item>
				<el-dropdown-item @click.native="people"  v-if='user.is_verify==3 && is_company===true'>切换个人账号</el-dropdown-item>
                <el-dropdown-item @click.native="edit(0)" v-if="is_check==0">基础信息修改</el-dropdown-item>
				 <el-dropdown-item @click.native="edit(1)" v-if="is_check==0">作物配置调整</el-dropdown-item>
				 <el-dropdown-item v-if="is_check==3">资料审核中</el-dropdown-item>
				 <el-dropdown-item @click.native="informationEdit" v-if="is_check==1 && farm_id>0 && is_pri==1">园区信息修改</el-dropdown-item>
                <el-dropdown-item @click.native="staffing"  v-if='is_check==1 && farm_id>0 && is_pri==1'>人员配置</el-dropdown-item>
				
				  <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
      </div>
  </div>
</template>

<script>
import {getUserInfo,getFarmUserPri} from '@/api/api'
export default {
  name: 'homeheader',
    props: {
        isActive:{
            type: Boolean,
            default() {return false}
        },
		is_company:{
		    type: Boolean,
		    default() {return false}
		},
        title:{
            type: String,
            default() {return '植物全生命周期管理系统'}
        },
        is_check:{
            type: Number,
            default() {return 1}
        },
		is_top:{
		    type: String,
		    default() {return 'http://eyesoss.xxnsnzy.com/images/top_bj.png'}
		},
		farm_id:{
		    type: Number,
		    default() {return 23}
		},
		
    },
  data(){
    return {
   
   is_pri:0,
	 user:[],	
    }
  },
 
  created() {
	
	  window.addEventListener("scroll", this.handleScroll);
  	 this.get_user_info()
	 
	// console.log(status+"aaaaaaaaaaaa")
	// console.log(this.user)
  },
  methods:{
	  get_user_info(){
	      getUserInfo().then(resp=>{
	          this.user=resp;
			  //console.log(resp)
	      })
		 
			  getFarmUserPri(this.farm_id).then(resp=>{
				  this.is_pri=resp
			  })
		  
	  },
	  dropDown(){
		console.log("dropDown")  
	  },
    searchClick(){
		console.log("adad")
		this.get_user_info()
      this.$emit('search','');
    },
    messageClick(){
      this.$emit('message','');
    },
    set(){
        this.$router.push('/set');
    },
	
    // 园区人员配置
    staffing(){
      this.$router.push('/staffing/'+this.farm_id);
    },
	person(){
	  this.$router.push('/attestation/realName');
	},
	company(){
	  this.$router.push('/attestation/company');
	},
	people(){
	  this.$router.push('/');
	},
	enterprise(){
		this.$router.push('/enterprise');
	},
	enterpriseSet(){
		this.$router.push('/enterprise/set');
	},
	// 园区人员配置
	logout(){
		localStorage.setItem("token",'')
	  this.$router.push('/login');
	},
    // 园区信息修改
    informationEdit(){
      this.$router.push('/informationEdit/'+this.farm_id);
    },
	edit(type){
		this.$router.push({ path: '/park/edit/'+this.farm_id, query: { type: type }});
	 // this.$router.push('/park/edit/'+this.farm_id,params: { userId: 123 });
	},
    userClick(){
		// this.$router.push('/set');
		
	},
    handleScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      //设置背景颜色的透明读
      if (scrollTop) {
        //  this.style.backgroundColor = '#112153';
      } else if (scrollTop == 0) {
         // this.style.backgroundColor = "transparent";
      }
    },
  },

    beforeDestroy() {
        window.removeEventListener("scroll", this.handleScroll);
    },

}
</script>
<style scoped lang="less">
    .head{
        width: 100%;
        height: 80px;
        line-height: 80px;
        background-image: url("http://eyesoss.xxnsnzy.com/images/top_bj.png");
        background-repeat: repeat-x;
        /*background: url("../assets/images/home/top_bj_01.png") no-repeat;*/
        background-size: 100% 100%;
        position: fixed;
        top: 0;
        z-index: 1000;
        padding: 0 30px;
        transition: all linear 0.5s;

        .head_fl{
            font-size: 24px;
            //font-weight: 800;
            color: #FFFFFF;
            cursor: pointer;
        }
        .head_fr{
            display: flex;
            align-items: center;
            img{
                width: 26px;
                height: 26px;
                cursor: pointer;
            }
            .user_pic{
                width: 34px;
                height: 34px;
                border-radius: 50%;
            }
            span{
                color: #fff;
                font-size: 18px;
                font-weight: 500;
                padding: 0 20px 0 10px;
            }
            .el-dropdown{
                img{
                    vertical-align: middle;
                }
            }
            .message{
                width: 26px;
                height: 26px;
                margin: 0 19px;
            }
        }
    }
    .common_head{
        background-image: url("http://eyesoss.xxnsnzy.com/images/top_bj.png");
        background-size: 100% 100%;
    }
</style>

